import { render, staticRenderFns } from "./SideMenuPrograms.vue?vue&type=template&id=2baf1f9e&"
import script from "./SideMenuPrograms.vue?vue&type=script&lang=js&"
export * from "./SideMenuPrograms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\Simply\\Simply.Web.Website\\Static\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2baf1f9e')) {
      api.createRecord('2baf1f9e', component.options)
    } else {
      api.reload('2baf1f9e', component.options)
    }
    module.hot.accept("./SideMenuPrograms.vue?vue&type=template&id=2baf1f9e&", function () {
      api.rerender('2baf1f9e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Js/Components/SideMenuPrograms.vue"
export default component.exports